import { render, staticRenderFns } from "./stock-laboratoire.html?vue&type=template&id=bc63e552&scoped=true&external"
import script from "./stock-laboratoire.js?vue&type=script&lang=js&external"
export * from "./stock-laboratoire.js?vue&type=script&lang=js&external"
import style0 from "./stock-laboratoire.scss?vue&type=style&index=0&id=bc63e552&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc63e552",
  null
  
)

export default component.exports